<template>
  <Transition>
    <slot />
  </Transition>
</template>

<style scoped>
.v-leave-active {
  transition: opacity 0.15s;
}

.v-leave-to {
  opacity: 0;
}
</style>
